import React from "react";

import PropTypes from "prop-types";
import { Table, Header, Statistic, Image } from "semantic-ui-react";

const TrackListPlaceholder = ({ length }) => {
  return (
    <div>
      <Table unstackable inverted style={{ borderRadius: 0 }}>
        <Table.Header>
          <Table.Row />
        </Table.Header>
        <Table.Body>
          {new Array(length).fill(0).map((_, index) => {
            return <TrackListPlaceholderItem key={index} />;
          })}
        </Table.Body>
      </Table>
    </div>
  );
};

TrackListPlaceholder.propTypes = {
  length: PropTypes.number,
};
TrackListPlaceholder.defaultProps = {
  length: 8,
};

const TrackListPlaceholderItem = () => {
  return (
    <Table.Row>
      <Table.Cell width={1}>
        <Image style={{ width: "48px" }} src={`/vinyl-record-144x144.png`} />
      </Table.Cell>
      <Table.Cell>
        <Header as="h5" style={{ color: "#E9E9E9" }}>
          <Header.Content>
            <span
              style={{
                borderRadius: "3px",
                backgroundColor: "whitesmoke",
                color: "whitesmoke",
              }}
            >
              Track name
            </span>
            <Header.Subheader>
              <span
                style={{
                  borderRadius: "3px",
                  backgroundColor: "grey",
                  color: "grey",
                }}
              >
                Artist A, Artist B
              </span>
            </Header.Subheader>
          </Header.Content>
        </Header>
      </Table.Cell>
      <Table.Cell>
        <Statistic
          size={"mini"}
          color="green"
          style={{
            margin: 0,
            textAlign: "right",
          }}
        >
          <Statistic.Value
            style={{
              color: "gray",
              fontWeight: "bold",
            }}
          >
            0
          </Statistic.Value>
        </Statistic>
      </Table.Cell>
    </Table.Row>
  );
};

export default TrackListPlaceholder;
